import { EMAIL_VALIDATION_REGEX } from 'constants/UrlConstants';

import FormField from './FormField';
import Input from '../base/Input';

/**
 * @type {React.FC<{
 *  name: string,
 *  errorMessage?: string,
 *  required?: boolean,
 *  disabled?: boolean,
 *  labelId?: string,
 *  validateOnInit: boolean,
 *  defaultMessage?: string,
 *  inputProps?: import('antd/lib/input').InputProps,
 *  hideError?: boolean,
 *  label?: React.ReactNode,
 *  className?: import("classnames").Argument,
 *  validate?: ((value: string) => string | undefined) | null,
 * }>}
 */
const EmailInput = ({ disabled, defaultMessage, required, errorMessage = 'validation.email', inputProps = {}, ...formFieldProps }) => {
  const isEmailValid = email => {
    const isValid = email?.match(EMAIL_VALIDATION_REGEX);
    return isValid || (!email?.length && !required);
  };

  const validate = email => (isEmailValid(email) ? undefined : errorMessage);

  return (
    <FormField validate={validate} defaultTranslation={defaultMessage} required={required} {...formFieldProps}>
      {input => <Input data-cy="input_email" disabled={disabled} {...input} {...inputProps} />}
    </FormField>
  );
};

export default EmailInput;
